const UNDERSCORE_VERSION = '1.13.6';
// monkey patch backbone.marionette module creation to inject
// lodash instead of underscore into parameter list
const constructModule = function () {
    const args = arguments;
    const moduleDefFcn = args[1];
    // NOTE: first two params are module name and module definition function, rest are custom args.
    const customArgs = _.drop(args, 2);
    if (moduleDefFcn) {
        args[1] = function () {
            const me = this;
            const originalArgs = arguments;
            const index = _.findIndex(originalArgs, {
                VERSION: UNDERSCORE_VERSION
            });
            if (index > -1) {
                originalArgs[index] = window._;
            }
            // HACK: before this fcn is invoked, backbone.marionette calls (using underscore) {
            // let args = _.flatten([
            //     this,
            //     this.app,
            //     Backbone,
            //     Marionette,
            //     Backbone.$, _,
            //     customArgs
            //   ]);
            // }
            // the flatten is deep and destroys any customArgs we pass that are arrays. To avoid this,
            // take the first 6 args, which is everything up to our customArgs, and tack on our customArgs
            //  to preserve shape. see #29494.
            const newArgs = _.take(originalArgs, 6).concat(customArgs);
            moduleDefFcn.apply(me, newArgs);
        };
    }
    /* eslint-disable no-proto */
    const superFn = this.__proto__.module;
    return superFn.apply(this, args);
};

window.createMarionetteApp = function () {
    const newApp = new Marionette.Application();
    newApp.module = constructModule;
    return newApp;
};

window.createBackboneMarionetteApp = function () {
    const newApp = new Backbone.Marionette.Application();
    newApp.module = constructModule;
    return newApp;
};
